
import { useEffect, useMemo, useRef, useState } from "react";


import { useDispatch, useSelector } from "react-redux";
import { UniversalMapProps } from "./types/MapTypes";
import { PluginManager } from "./plugins/PluginManager";
import { RootState } from "./store/store";
import { createMapAdapter } from "./core/MapFactory";
import { MapContext } from "./core/MapContext";
import { PluginLoader } from "./plugins/PluginLoader";
import { DrawPlugin } from "./plugins/draw";
import { DRAW_SOURCE_ID } from "./plugins/draw/consts";
import { setDrawingMode } from "./store/slices/drawSlice";
import MapChromeControls from "./MapChromeControls";

interface GeoJSONGeometry
{
  type?: string;
  coordinates?: any;
}

interface IMultiGeometry
{
  geometry: GeoJSONGeometry;
}
interface ImagesMapProps extends UniversalMapProps
{
  onSetEngineMap?: any;
}

export default function ImagesMapVMRS({ mapType, view, style, className, children, onSetEngineMap, showBaseMap = false, showMapControl = false }: ImagesMapProps)
{
  const containerRef = useRef<HTMLDivElement>(null);
  const engineRef = useRef<any>(null);
  const pluginManager = useMemo(() => new PluginManager(), []);

  const { layers } = useSelector((state: RootState) => state.layer);
  const { selectedBasemap } = useSelector((state: RootState) => state.map);
  const dispatch = useDispatch()

  // Gate for all dependent effects — true after map fires its "load" event
  const [mapReady, setMapReady] = useState<boolean>(false);

  useEffect(() =>
  {
    if (!containerRef.current) return;

    const engine = createMapAdapter(mapType);
    engine.init(containerRef.current);
    engine.syncLayers(layers || []);
    engine.setBasemap(selectedBasemap);
    engineRef.current = engine;

    const map = engineRef.current.map;
    const onLoad = () => setMapReady(true);
    map?.loaded() ? onLoad() : map?.once("load", onLoad);
    if (onSetEngineMap) onSetEngineMap(map);
    // if (onSetEngineMap)
    // {
    //   map.loaded()
    //     ? onSetEngineMap(map)
    //     : map.once("load", () =>
    //     {
    //       setTimeout(() => onSetEngineMap(map), 200); // delay nhẹ
    //     });
    // }
    if (view) engine.setView(view);

    return () =>
    {
      setMapReady(false);
      const mapInstance = engineRef.current ? (mapType === "cesium" ? engineRef.current?.viewer : engineRef.current?.map) : null;

      pluginManager.clear({
        mapType,
        mapInstance,
        dispatch: () => { },
        getState: () => ({}),
      });
      engine.destroy();
    };
  }, [mapType]);

  // Sync layers
  useEffect(() =>
  {
    if (!mapReady || !engineRef.current) return;
    engineRef.current.syncLayers(layers || []);
  }, [mapReady, layers]);

  const { features } = useSelector((state: RootState) => state.draw);

  // useEffect(() =>
  // {
  //   if (!mapReady || !engineRef.current) return;

  //   const map = engineRef.current.map;
  //   const source = map.getSource(DRAW_SOURCE_ID);

  //   if (!source)
  //   {
  //     console.log("❌ draw source chưa tồn tại");
  //     return;
  //   }

  //   source.setData({
  //     type: "FeatureCollection",
  //     features: features.map((f: any) => ({
  //       type: "Feature",
  //       id: f.id,
  //       properties: {
  //         color: f.fill,
  //         stroke_color: f.stroke,
  //       },
  //       geometry: f.geometry,
  //     })),
  //   });

  //   console.log("✅ updated draw source", features);
  // }, [features, mapReady]);

  //! functions

  useEffect(() =>
  {
    if (!mapReady) return;

    dispatch(setDrawingMode("VIEW"));
    setTimeout(() => dispatch(setDrawingMode("NONE")), 1000);
  }, [features]);
  return (
    <MapContext.Provider
      value={{
        engine: engineRef.current,
        pluginManager,
        mapType,
        mapInstance: engineRef.current ? (mapType === "cesium" ? engineRef.current.viewer : engineRef.current.map) : null,
      }}
    >
      {mapReady && children}
      {/* Same controls as UniversalMap (basemap / layers, zoom, compass, coordinates) — opt in via props. */}
      {mapReady && (showBaseMap || showMapControl) && (
        <MapChromeControls engineRef={engineRef} mapType={mapType} showBaseMap={showBaseMap} showMapControl={showMapControl} />
      )}

      <PluginLoader plugin={DrawPlugin} />
      <div ref={containerRef} className={className} style={{ width: "100%", height: "100%", ...style }} />
    </MapContext.Provider>
  );
}


